import type { RefObject } from 'react';
import { createContext, useContext } from 'react';

type SectionRefsContextType = {
  registerSectionRef: (sectionId: string, ref: RefObject<HTMLDivElement>) => void;
  getSectionRef: (sectionId: string) => RefObject<HTMLDivElement> | undefined;
  sectionRefs: React.RefObject<HTMLDivElement>[];
};

export const SectionRefsContext = createContext<SectionRefsContextType | undefined>(undefined);

export const useSectionRefs = () => {
  const context = useContext(SectionRefsContext);
  if (!context) {
    throw new Error('useSectionRefs must be used within a SectionRefsProvider');
  }
  return context;
};
